import type { ScreenProps } from '../../app/types';
import { Card, InfoRow, ScrollTable } from '../../components/ui';
import { EntityLink } from '../../components/EntityLink';
import { analysisMetrics } from './metrics';

export default function AnalysisScreen({ state, navigate }: ScreenProps) {
  const metrics = analysisMetrics(state);
  const statistics = [
    [metrics.totalSows, 'Cerdas totales'], [metrics.pregnantSows, 'Gestantes'], [metrics.emptySows, 'Vacías'],
    [metrics.totalBirths, 'Partos históricos'], [metrics.averageBorn, 'Prom. nacidos vivos'], [metrics.prolificSows, 'Cerdas prolíficas'],
    [metrics.activeLots, 'Lotes activos'], [metrics.boars, 'Verracos'], [`${metrics.mortalityPercent}%`, 'Mortalidad global'],
  ] as const;
  return <>
    <Card><h2>Panorama general de la finca</h2><div className="stat-grid">{statistics.map(([number, label]) => <div className="stat" key={label}><div className="num">{number}</div><div className="lab">{label}</div></div>)}</div></Card>
    <Card><h2>Rendimiento por lote (conversión alimenticia)</h2>
      {!metrics.lotPerformance.length ? <div className="muted">Aún no hay suficientes datos de alimentación registrados.</div> : <ScrollTable label="Rendimiento por lote">
        <thead><tr><th scope="col">Lote</th><th scope="col">Libras consumidas</th><th scope="col">Libras ganadas</th><th scope="col">Conversión</th></tr></thead>
        <tbody>{metrics.lotPerformance.map(record => <tr key={record.lotId}><td><EntityLink state={state} navigate={navigate} reference={{ type: 'lote', id: record.lotId }}><b>{record.lotId}</b></EntityLink></td><td>{record.feed}</td><td>{record.gain.toFixed(0)}</td><td>{record.conversion}</td></tr>)}</tbody>
      </ScrollTable>}
    </Card>
    <Card><h2>Mortalidad por etapa</h2>{metrics.mortalityByStage.map(({ stage, total }) => <InfoRow key={stage} label={stage}>{total}</InfoRow>)}</Card>
  </>;
}
